/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MdmMatchPreviewEntitySummary
 */
export interface MdmMatchPreviewEntitySummary {
    /**
     * 
     * @type {string}
     * @memberof MdmMatchPreviewEntitySummary
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmMatchPreviewEntitySummary
     */
    sourceSystem?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmMatchPreviewEntitySummary
     */
    hostname?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmMatchPreviewEntitySummary
     */
    hardwareUuid?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MdmMatchPreviewEntitySummary
     */
    ipAddresses?: Array<string>;
}

/**
 * Check if a given object implements the MdmMatchPreviewEntitySummary interface.
 */
export function instanceOfMdmMatchPreviewEntitySummary(value: object): value is MdmMatchPreviewEntitySummary {
    return true;
}

export function MdmMatchPreviewEntitySummaryFromJSON(json: any): MdmMatchPreviewEntitySummary {
    return MdmMatchPreviewEntitySummaryFromJSONTyped(json, false);
}

export function MdmMatchPreviewEntitySummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): MdmMatchPreviewEntitySummary {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'sourceSystem': json['sourceSystem'] == null ? undefined : json['sourceSystem'],
        'hostname': json['hostname'] == null ? undefined : json['hostname'],
        'hardwareUuid': json['hardwareUuid'] == null ? undefined : json['hardwareUuid'],
        'ipAddresses': json['ipAddresses'] == null ? undefined : json['ipAddresses'],
    };
}

export function MdmMatchPreviewEntitySummaryToJSON(json: any): MdmMatchPreviewEntitySummary {
    return MdmMatchPreviewEntitySummaryToJSONTyped(json, false);
}

export function MdmMatchPreviewEntitySummaryToJSONTyped(value?: MdmMatchPreviewEntitySummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'sourceSystem': value['sourceSystem'],
        'hostname': value['hostname'],
        'hardwareUuid': value['hardwareUuid'],
        'ipAddresses': value['ipAddresses'],
    };
}

